import React, { DOMAttributes, ReactElement } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Key } from 'antd/es/table/interface';
import {
  SContainer,
  SInner,
  SExpandIcon,
  SLabel,
  SBadge,
} from './permission-cell.style';
import { ERoleRecordKey } from '../../table.enums';
import { isScopeRecord } from '../../table.utils';

export const PermissionCellComponent = ({
  value,
  record,
  expandedRows,
  onToggleExpand,
}: {
  value: string;
  record: any;
  expandedRows: Key[];
  onToggleExpand: (recordKey: Key) => void;
}): ReactElement => {
  const expanded = expandedRows?.includes(record[ERoleRecordKey.Key]);
  const isScopeRow = isScopeRecord(record);

  const handleClick: DOMAttributes<HTMLDivElement>['onClick'] = (): void => {
    if (isScopeRecord(record)) {
      onToggleExpand(record.key);
    }
  };

  return (
    <SContainer
      style={{
        background: isScopeRow ? 'rgb(250, 250, 250)' : 'transparent',
      }}
      onClick={handleClick}
    >
      <SInner>
        {isScopeRow && <SExpandIcon>{expanded ? <DownOutlined /> : <UpOutlined />}</SExpandIcon>}
        <SLabel>{value}</SLabel>
      </SInner>
      {isScopeRow && <SBadge>{record.children.length}</SBadge>}
    </SContainer>
  );
};
